

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getSubjectsByclassId } from "../../lib/ClassApi";

import {
    getLiveClasses

} from "../../lib/LiveClass";
import { useAuth } from "../../context/AuthProvider";

import { getContentsByTopicID, getChapterTopic, getTopicsByChapter } from "../../lib/LiveclassContent";

function Calendar() {

    const [filters, setFilters] = useState({});

    const [sessions, setSessions] = useState([]);

    const [subjectsList, setSubjectsList] = useState([]);

    const [contentList, setContentList] = useState([]);

    const [selectedSession, setSelectedSession] = useState(null);

    const [topicContents, setTopicContents] = useState([]);

    const [contentLoading, setContentLoading] = useState(false);

    const [seenTopics, setSeenTopics] = useState({});
    const navigate = useNavigate();

    // const user = JSON.parse(
    //     localStorage.getItem("user") || "{}"
    // );
    const { user } = useAuth();

    const role =
        user?.roleName?.toLowerCase() ||
        user?.role?.toLowerCase();

    const isTeacher = role === "teacher";
    const isStudent = role === "student";
    const isAdmin = role === "admin";

    const teacherRows = sessions.flatMap((group) =>
        group.sessions.map((session) => ({
            ...session,
            subject: group.subject,
        }))
    );

    const teacherClassSubjects = teacherRows.reduce((options, session) => {
        const key = `${session.className || "All classes"}-${session.subjectId || session.subject}`;

        if (!options.some((option) => option.key === key)) {
            options.push({
                key,
                value: session.subjectId || session.subject,
                label: `${session.className || "Class"} · ${session.subject}`,
            });
        }

        return options;
    }, []);

    // ================= GET CLASS =================

    // useEffect(() => {

    //     const storedUser =
    //         localStorage.getItem("user");

    //     if (storedUser) {

    //         const userData =
    //             JSON.parse(storedUser);

    //         if (
    //             userData?.UserClasses &&
    //             userData.UserClasses.length > 0
    //         ) {

    //             setFilters((prev) => ({

    //                 ...prev,

    //                 classId:
    //                     userData.UserClasses[0]
    //                         .ClassId,
    //             }));
    //         }
    //     }

    // }, []);

    useEffect(() => {

        if (isTeacher) return;

        const storedUser =
            localStorage.getItem("user");

        if (storedUser) {

            const userData =
                JSON.parse(storedUser);

            if (
                userData?.UserClasses &&
                userData.UserClasses.length > 0
            ) {

                setFilters((prev) => ({

                    ...prev,

                    classId:
                        userData.UserClasses[0]
                            .ClassId,
                }));
            }
        }

    }, [isTeacher]);

    // ================= GET SUBJECT =================

    useEffect(() => {

        if (isTeacher) return;

        if (filters.classId) {

            fetchSubjects(filters.classId);

        } else {

            setSubjectsList([]);
        }

    }, [filters.classId]);

    const fetchSubjects = async (classId) => {

        try {

            const res =
                await getSubjectsByclassId(
                    classId
                );

            if (res.success) {

                setSubjectsList(
                    res.data || []
                );
            }

        } catch (err) {

            console.error(err);
        }
    };

    // ================= FETCH LIVE CLASSES =================

    const fetchSessions = async () => {

        try {

            const userId =
                user?.uuid ||
                user?.id ||
                localStorage.getItem(
                    "userId"
                );

            const schoolId =
                user?.SchoolId ||
                user?.schoolId ||
                localStorage.getItem("schoolId");

            console.log("Live Classes Request:", {
                userId,
                schoolId
            });

            const res =
                await getLiveClasses(
                    userId, schoolId
                );

            const apiData =
                res.data || [];

            console.log(
                "LIVE CLASS:",
                apiData
            );

            // ================= FILTER =================

            const filtered =
                apiData.filter((item) => {

                    const itemDate =
                        new Date(
                            item.startdatetime
                        );

                    return (

                        (!filters.subject ||
                            item.subjectId ==
                            filters.subject)

                        &&

                        (!filters.className ||
                            (item.classname || item.className) ===
                            filters.className)

                        &&

                        (!filters.month ||
                            itemDate.toLocaleString("default", { month: "short" }) ===
                            filters.month)

                        &&

                        (!filters.year ||
                            itemDate
                                .getFullYear()
                                .toString() ===
                            filters.year)

                        &&

                        (!filters.date ||
                            itemDate
                                .toISOString()
                                .split("T")[0] ===
                            filters.date)
                    );
                });

            // ================= GROUP BY SUBJECT =================

            const grouped =
                filtered.reduce(
                    (acc, item) => {

                        const subject =
                            item.subjectName;

                        if (
                            !acc[subject]
                        ) {

                            acc[subject] =
                                [];
                        }

                        const dateObj =
                            new Date(
                                item.startdatetime
                            );

                        acc[subject].push({

                            // id: item.id,

                            // classId:
                            //     item.classId,

                            // subjectId:
                            //     item.subjectId,

                            // chapter:
                            //     item.chapter,

                            // id: item.id,

                            // chapterId: item.chapterId || item.chapterID,

                            // classId: item.classId,

                            // subjectId: item.subjectId,

                            // chapter: item.chapter,
                            id: item.id,

                            sessionId: item.sessionId,

                            chapterId:
                                item.chapterId ||
                                item.chapterID,

                            classId: item.classId,

                            className:
                                item.classname ||
                                item.className,

                            batchName:
                                item.batchName,

                            subjectId:
                                item.subjectId,

                            subjectName:
                                item.subjectName,

                            chapter:
                                item.chapter,

                            topic:
                                item.topic,

                            year:
                                dateObj.getFullYear(),

                            month:
                                dateObj.toLocaleString(
                                    "default",
                                    {
                                        month:
                                            "short",
                                    }
                                ),

                            date: dateObj
                                .toLocaleDateString(
                                    "en-GB",
                                    {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    }
                                )
                                .replace(
                                    / /g,
                                    "-"
                                ),

                            completed:
                                !!item.recordedVideoUrl,

                            active:
                                new Date() >=
                                dateObj,

                            expanded:
                                false,

                            topics: [],
                        });

                        // acc[subject].push({

                        //     id: item.id,

                        //     classId: item.classId,

                        //     subjectId: item.subjectId,

                        //     chapter: item.chapter,

                        //     year: dateObj.getFullYear(),

                        //     month: dateObj.toLocaleString("default", {
                        //         month: "short",
                        //     }),

                        //     date: dateObj
                        //         .toLocaleDateString("en-GB", {
                        //             day: "2-digit",
                        //             month: "short",
                        //             year: "numeric",
                        //         })
                        //         .replace(/ /g, "-"),

                        //     completed: !!item.recordedVideoUrl,

                        //     active: new Date() >= dateObj,

                        //     expanded: false,

                        //     topics: [],
                        // });


                        return acc;

                    },
                    {}
                );

            // ================= FINAL DATA =================

            const finalData =
                Object.keys(grouped).map(
                    (subject) => ({

                        subject,

                        sessions:
                            grouped[
                            subject
                            ],
                    })
                );

            setSessions(finalData);

        } catch (err) {

            console.error(
                "Session Error:",
                err
            );
        }
    };

    useEffect(() => {

        fetchSessions();

    }, [filters]);


    //==============Topic Tracking  Storage====================
    useEffect(() => {

        const storedProgress =
            localStorage.getItem(
                "seenTopics"
            );

        if (storedProgress) {

            setSeenTopics(
                JSON.parse(storedProgress)
            );
        }

    }, []);

    // ================= CHAPTER CLICK =================

    const handleChapterClick = async (
        subjectIndex,
        sessionIndex,
        session
    ) => {

        try {

            const alreadyOpen =
                sessions[subjectIndex]
                    .sessions[sessionIndex]
                    .expanded;

            // CLOSE ALL
            const updated = sessions.map((group) => ({
                ...group,
                sessions: group.sessions.map((s) => ({
                    ...s,
                    expanded: false,
                })),
            }));

            // CLOSE CURRENT
            if (alreadyOpen) {

                setSessions(updated);

                return;
            }

            console.log("CLICKED SESSION:", session);

            let topics = [];

            try {

                // ================= API CALL =================

                const res = await getTopicsByChapter(
                    Number(session.chapterId)
                );

                console.log("TOPICS API:", res);

                const topicData =
                    res?.data || res || [];

                topics = topicData.map((item) => ({

                    topicId:
                        item.topicid ||
                        item.topicId ||
                        item.TopicId,

                    topicName:
                        item.topicname ||
                        item.topicName ||
                        item.TopicName,
                }));

            } catch (apiErr) {

                console.log(
                    "NO TOPICS FOUND OR API ERROR"
                );

                // EMPTY ARRAY
                topics = [];
            }

            // ================= OPEN CURRENT =================

            updated[subjectIndex]
                .sessions[sessionIndex] = {

                ...updated[subjectIndex]
                    .sessions[sessionIndex],

                expanded: true,

                topics,
            };

            setSessions(updated);

        } catch (err) {

            console.error(
                "Chapter Click Error:",
                err
            );
        }
    };

    //==================== Handler TopicClick ======================

    const handleTopicClick = async (
        topic,
        session,
        subject
    ) => {

        try {

            setContentLoading(true);

            console.log("TOPIC:", topic);

            const topicId = topic.topicId;

            if (!topicId) {

                console.log("INVALID TOPIC ID");

                setTopicContents([]);

                return;
            }

            // ================= SAVE TOPIC SEEN =================

            setSeenTopics((prev) => {

                const chapterId =
                    session.chapterId;

                const existingTopics =
                    prev[chapterId] || [];

                // already opened
                if (
                    existingTopics.includes(
                        topicId
                    )
                ) {

                    return prev;
                }

                const updated = {

                    ...prev,

                    [chapterId]: [
                        ...existingTopics,
                        topicId,
                    ],
                };

                // SAVE TO LOCALSTORAGE

                localStorage.setItem(
                    "seenTopics",
                    JSON.stringify(updated)
                );

                return updated;
            });

            // ================= API =================

            const res =
                await getContentsByTopicID(
                    topicId
                );

            console.log(
                "CONTENT API:",
                res
            );

            // ================= RESPONSE =================

            const contentData =
                res?.data || res || [];

            // ================= ONLY LIVE =================

            const liveContents =
                contentData.filter(
                    (item) =>
                        item.islive === true
                );

            console.log(
                "LIVE CONTENTS:",
                liveContents
            );

            // ================= SET CONTENT =================

            setTopicContents(
                liveContents
            );

            // ================= SET HEADER =================

            setSelectedSession({

                topic:
                    topic.topicName,

                chapter:
                    session.chapter,

                subject:
                    subject,
            });

        } catch (err) {

            console.error(
                "Content Error:",
                err
            );

            setTopicContents([]);

        } finally {

            setContentLoading(false);
        }
    };

    //     const handleTopicClick = async (topic) => {

    //     try {

    //         console.log("TOPIC:", topic);

    //         const topicId = topic.topicId;

    //         if (!topicId) {

    //             console.log("INVALID TOPIC ID");

    //             setContentList([]);

    //             return;
    //         }

    //         const res = await getContentsByTopicID(topicId);

    //         console.log("CONTENT API RESPONSE:", res);

    //         // RESPONSE HANDLE
    //         const contentData =
    //             res?.data || res || [];

    //         // ONLY LIVE CONTENT
    //         const liveContents = contentData.filter(
    //             (item) => item.islive === true
    //         );

    //         console.log(
    //             "LIVE CONTENTS:",
    //             liveContents
    //         );

    //         setContentList(liveContents);

    //     } catch (err) {

    //         console.error(
    //             "Content Error:",
    //             err
    //         );

    //         setContentList([]);
    //     }
    // };

    // ================= FILTER HANDLE =================

    const handleChange = (e) => {

        setFilters({

            ...filters,

            [e.target.name]:
                e.target.value,
        });
    };


    ///==================Group Content======================
    const groupedContents =
        topicContents.reduce(
            (acc, item) => {

                const type =
                    (
                        item.mediatype ||
                        item.mediaType ||
                        ""
                    )
                        .toLowerCase();

                if (!acc[type]) {

                    acc[type] = [];
                }

                acc[type].push(item);

                return acc;

            },
            {}
        );

    //====================== Chapter progress Tracking ==================

    const getChapterProgress = (
        session
    ) => {

        const totalTopics =
            session.topics?.length || 0;

        const seenCount =
            seenTopics[
                session.chapterId
            ]?.length || 0;

        return {

            completed:
                totalTopics > 0 &&
                seenCount === totalTopics,

            partial:
                seenCount > 0 &&
                seenCount < totalTopics,
        };
    };

    return (

        <div className="min-h-screen bg-[#f7f3ea] p-4 md:p-8 text-[#17145b]">

            <div className="mb-6 flex items-center justify-between rounded-[18px] bg-[#4338ca] px-6 py-5 text-white shadow-sm">
                <h1 className="text-xl md:text-2xl font-extrabold uppercase tracking-tight">Annual calendar | schedule</h1>
                <span className="text-lg opacity-80">⌂</span>
            </div>

            {/* ================= FILTER ================= */}

            <div className="mb-6">

                <div className="flex items-center justify-between mb-3">
                    <p className="text-sm font-medium text-[#69658c]">Filter by:</p>
                    {isTeacher && (
                        <p className="text-xs text-[#8b87a8]">Filled = MWF batch · Outline = TTS batch · Red = live right now</p>
                    )}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {/* YEAR */}

                    <div>

                        <select
                            name="year"
                            value={
                                filters.year ||
                                "2026"
                            }
                            onChange={
                                handleChange
                            }
                            className="w-full p-3 rounded-xl bg-white border border-[#ddd7c9] text-[#17145b]"
                        >

                            <option value="2020"> 2020  </option>
                            <option value="2021"> 2021  </option>
                            <option value="2022"> 2022  </option>
                            <option value="2023"> 2023  </option>
                            <option value="2024"> 2024  </option>
                            <option value="2025"> 2025  </option>
                            <option value="2026">2026–27</option>
                        </select>

                        <p className="text-xs mt-1 text-[#8b87a8]">(Academic year)</p>
                    </div>

                    {/* DATE */}

                    <div>

                        {isTeacher ? (
                            <select
                                name="month"
                                value={filters.month || ""}
                                onChange={handleChange}
                                className="w-full p-3 rounded-xl bg-white border border-[#ddd7c9] text-[#17145b]"
                            >
                                <option value="">All months</option>
                                {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map((month) => (
                                    <option key={month} value={month}>{month}</option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type="date"
                                name="date"
                                value={filters.date || ""}
                                onChange={handleChange}
                                className="w-full p-3 rounded-xl bg-white border border-[#ddd7c9] text-[#17145b]"
                            />
                        )}

                        <p className="text-xs mt-1 text-[#8b87a8]">(Date)</p>
                    </div>

                    {/* SUBJECT */}

                    <div>

                        <select
                            name="subject"
                            value={
                                filters.subject ||
                                ""
                            }
                            onChange={
                                handleChange
                            }
                            className="w-full p-3 rounded-xl bg-white border border-[#ddd7c9] text-[#17145b]"
                        >

                            <option value="">{isTeacher ? "Class and subject" : "All Subjects"}</option>
                            {isTeacher
                                ? teacherClassSubjects.map((option) => (
                                    <option key={option.key} value={option.value}>
                                        {option.label}
                                    </option>
                                ))
                                : Array.isArray(subjectsList) && subjectsList.map(
                                    (sub) => (

                                        <option
                                            key={
                                                sub.subjectId
                                            }
                                            value={
                                                sub.subjectId
                                            }
                                        >

                                            {
                                                sub.subjectName
                                            }

                                        </option>
                                    )
                                )}

                        </select>

                        <p className="text-xs mt-1 text-[#8b87a8]">{isTeacher ? "(Class and subject)" : "(Subject)"}</p>
                    </div>

                </div>

            </div>

            {/* ================= SESSION UI ================= */}

            {!isTeacher && !selectedSession && (

                <div className="overflow-x-auto rounded-2xl border border-[#e5dfd2] bg-white p-5 shadow-sm">

                    <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
                        <h2 className="text-lg font-bold">{sessions[0]?.subject || "Calendar schedule"}</h2>
                        <div className="flex items-center gap-4 text-xs text-[#69658c]">
                            <span><i className="mr-1 inline-block h-3 w-3 rounded-full bg-[#16835d]" />Done</span>
                            <span><i className="mr-1 inline-block h-3 w-3 rounded-full bg-[#b47708]" />In progress</span>
                            <span><i className="mr-1 inline-block h-3 w-3 rounded-full bg-[#ded8c9]" />Upcoming</span>
                        </div>
                    </div>

                    <div className="mb-2 grid min-w-[680px] grid-cols-[80px_80px_160px_1fr_50px] gap-2 border-b border-[#e5dfd2] px-2 pb-3 text-xs font-semibold uppercase tracking-wider text-[#817b9d]">
                        <span>Year</span><span>Month</span><span>Date</span><span>Chapter or topic</span><span>Status</span>
                    </div>

                    {sessions.length === 0 ? (

                        <p>No data</p>

                    ) : (

                        sessions.map(
                            (
                                group,
                                index
                            ) => (

                                <div
                                    key={index}
                                    className="mb-8"
                                >

                                    {/* SUBJECT */}

                                    <h2 className="font-semibold text-lg mb-4">

                                        {
                                            group.subject
                                        }

                                    </h2>

                                    {/* ROWS */}

                                    <div className="space-y-2">

                                        {group.sessions.map(
                                            (
                                                s,
                                                i
                                            ) => (

                                                <div
                                                    key={
                                                        i
                                                    }
                                                >

                                                    {/* CHAPTER ROW */}

                                                    <div
                                                        // onClick={() =>
                                                        //     handleChapterClick(
                                                        //         index,
                                                        //         i,
                                                        //         s
                                                        //     )
                                                        // }

                                                        onClick={() => {

                                                            if (!isTeacher) {

                                                                handleChapterClick(
                                                                    index,
                                                                    i,
                                                                    s
                                                                );
                                                            }

                                                        }}


                                                        className={`grid min-w-[680px] grid-cols-[80px_80px_160px_1fr_50px] gap-2 items-center border-b border-[#eee9df] px-2 py-3 cursor-pointer transition hover:bg-[#faf8f2]`}
                                                    >

                                                        {/* YEAR */}

                                                        <div className="px-2 py-1 text-sm text-center">

                                                            {
                                                                s.year
                                                            }

                                                        </div>

                                                        {/* MONTH */}

                                                        <div className="px-2 py-1 text-sm text-center">

                                                            {
                                                                s.month
                                                            }

                                                        </div>

                                                        {/* DATE */}

                                                        <div className="px-2 py-1 text-sm text-center font-mono">

                                                            {
                                                                s.date
                                                            }

                                                        </div>

                                                        {/* CHAPTER */}

                                                        <div
                                                            // className={`border border-gray-400 px-2 py-1 text-sm flex justify-between items-center cursor-pointer ${s.active
                                                            //     ? "bg-[#bfbfbf] text-black"
                                                            //     : "bg-[#bfbfbf]"
                                                            //     }`}

                                                             className={`px-2 py-1 text-sm flex justify-between items-center cursor-pointer

                                                                 ${getChapterProgress(s).completed
                                                                    ? "bg-green-500 text-black"

                                                                    : getChapterProgress(s).partial
                                                                        ? "bg-yellow-200 text-black"

                                                                        : "bg-[#bfbfbf]"
                                                                }
                                                        `}
                                                        >

                                                            <div className="font-medium">
                                                                {s.chapter}
                                                            </div>

                                                            {isTeacher && (

                                                                <div className="text-xs text-gray-500 mt-1">

                                                                    <div>
                                                                        Class :
                                                                        {s.className}
                                                                    </div>

                                                                    <div>
                                                                        Batch :
                                                                        {s.batchName}
                                                                    </div>

                                                                </div>

                                                            )}


                                                            {/* <span>

                                                                {
                                                                    s.chapter
                                                                }

                                                            </span> */}

                                                            {/* <span>

                                                                {s.expanded
                                                                    ? "▾"
                                                                    : "↗"}

                                                            </span> */}

                                                            {!isTeacher && (
                                                                <span>
                                                                    {s.expanded ? "▾" : "↗"}
                                                                </span>
                                                            )}

                                                        </div>

                                                        {/* STATUS */}

                                                        <div className="flex justify-center">

                                                            <div
                                                                className={`h-3 w-3 rounded-full flex items-center justify-center ${getChapterProgress(s).completed
                                                                    ? "bg-[#16835d] text-white"
                                                                    : getChapterProgress(s).partial
                                                                        ? "bg-[#b47708]"
                                                                        : "bg-[#ded8c9]"
                                                                    }`}
                                                            >

                                                                {getChapterProgress(s).completed
                                                                    ? "✓"
                                                                    : ""}

                                                            </div>

                                                        </div>

                                                    </div>

                                                    {/* ================= TOPIC DROPDOWN ================= */}

                                                    {/* {s.expanded && ( */}
                                                    {!isTeacher &&
                                                        s.expanded && (

                                                            <div className="ml-[345px] w-auto mr-[58px] my-1 space-y-2">

                                                                {s.topics
                                                                    ?.length >
                                                                    0 ? (

                                                                    s.topics.map(
                                                                        (
                                                                            topic,
                                                                            idx
                                                                        ) => (

                                                                            <div
                                                                                key={
                                                                                    idx
                                                                                }
                                                                                onClick={() =>
                                                                                    handleTopicClick(
                                                                                        topic,
                                                                                        s,
                                                                                        group.subject
                                                                                    )
                                                                                }
                                                                                // className="bg-transparent border border-gray-300 rounded px-4 py-1 cursor-pointer hover:bg-[#bfbfbf]"

                                                                                className={`border border-gray-400 px-2 py-1 text-sm flex justify-between items-center cursor-pointer
                                                                            ${seenTopics[s.chapterId]?.includes(topic.topicId)

                                                                                        ? "bg-green-500 text-white"

                                                                                        : "bg-transparent hover:bg-[#bfbfbf]"
                                                                                    }
                                                                             `}
                                                                            >

                                                                                <div className="flex hover:text-blue-600 items-center w-[300px]">

                                                                                    <span >
                                                                                        {
                                                                                            topic.topicName
                                                                                        }
                                                                                    </span>

                                                                                    <span className="ml-4">
                                                                                        ▶
                                                                                    </span>

                                                                                </div>

                                                                            </div>
                                                                        )
                                                                    )

                                                                ) : (

                                                                    <div className="bg-white border px-4 py-2 rounded text-sm text-gray-500">

                                                                        No Topics Found

                                                                    </div>
                                                                )}

                                                            </div>
                                                        )}

                                                </div>
                                            )
                                        )}

                                    </div>

                                </div>
                            )
                        )
                    )}

                </div>
            )}

            {/* ================= TEACHER UI ================= */}
            {isTeacher && (
                <div className="space-y-5">
                    {/* <section className="bg-white rounded-2xl border border-[#e4dfd4] shadow-sm p-5 overflow-x-auto">
                        <h2 className="text-xl font-bold text-[#17145b] mb-4">Weekly grid — both batches</h2>
                        <table className="w-full min-w-[760px] text-sm text-[#17145b]">
                            <thead>
                                <tr className="border-b border-[#e4dfd4] text-xs uppercase tracking-wider text-[#817b9d]">
                                    <th className="text-left py-3">Slot</th>
                                    {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                                        <th key={day} className="text-center py-3">{day}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {[['4–5 PM', 'C9 MWF', 'C9 TTS'], ['5–6 PM', 'C8 MWF', 'C8 TTS']].map(([slot, mwf, tts]) => (
                                    <tr key={slot} className="border-b border-[#eee9df] last:border-0">
                                        <td className="py-3 font-medium">{slot}</td>
                                        {['mwf', 'tts', 'mwf', 'tts', 'mwf', 'tts'].map((batch, index) => (
                                            <td key={`${slot}-${index}`} className="text-center py-3">
                                                <span className={`inline-flex rounded-full px-4 py-2 font-semibold ${batch === 'mwf' ? 'bg-[#4338ca] text-white' : 'border border-[#d8cfbd] text-[#17145b]'} ${index === 2 && slot === '4–5 PM' ? 'bg-[#c9472e] border-[#c9472e]' : ''}`}>
                                                    {batch === 'mwf' ? mwf : tts}
                                                </span>
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section> */}

                    <section className="bg-white rounded-2xl border border-[#e4dfd4] shadow-sm p-5 overflow-x-auto">
                        <h2 className="text-xl font-bold text-[#17145b] mb-4">{teacherRows[0]?.className || 'Class'} {teacherRows[0]?.subject || 'subject'} — syllabus progress</h2>
                        <table className="w-full min-w-[700px] text-sm text-[#17145b]">
                            <thead>
                                <tr className="border-b border-[#e4dfd4] text-xs uppercase tracking-wider text-[#817b9d]">
                                    <th className="text-left py-3">Month</th>
                                    <th className="text-left py-3">Date</th>
                                    <th className="text-left py-3">Chapter</th>
                                    <th className="text-left py-3">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {teacherRows.map((session) => {
                                    const status = session.completed ? 'Complete' : session.active ? 'In progress' : 'Upcoming';
                                    return (
                                        <tr key={session.id || `${session.date}-${session.chapter}`} className="border-b border-[#eee9df] last:border-0">
                                            <td className="py-4">{session.month}</td>
                                            <td className="py-4 font-mono">{session.date}</td>
                                            <td className="py-4">{session.chapter}</td>
                                            <td className="py-4">
                                                <span className={`inline-flex rounded-full px-4 py-2 font-semibold ${status === 'Complete' ? 'bg-[#16835d] text-white' : status === 'In progress' ? 'bg-[#b47708] text-white' : 'bg-[#ded8c9] text-[#696052]'}`}>
                                                    {status}
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </section>
                </div>
            )}
            {/* ================= CONTENT SCREEN ================= */}

            {isStudent &&
                selectedSession && (

                    <div className="mt-8 bg-white rounded-2xl shadow border p-6">

                        {/* HEADER */}

                        <div className="flex justify-between items-center mb-6">

                            <div>

                                <h2 className="text-2xl font-bold text-purple-700">

                                    {selectedSession.topic}

                                </h2>

                                <p className="text-gray-500 mt-1">

                                    {selectedSession.subject}
                                    {" • "}
                                    {selectedSession.chapter}

                                </p>

                            </div>

                            <button

                                onClick={() => {

                                    setSelectedSession(null);

                                    setTopicContents([]);

                                }}

                                className="border border-purple-600 text-purple-600 px-4 py-2 rounded-lg hover:bg-purple-50"
                            >

                                Back

                            </button>

                        </div>

                        {/* LOADING */}

                        {contentLoading ? (

                            <div className="text-center py-10">

                                Loading contents...

                            </div>

                        ) : topicContents.length === 0 ? (

                            <div className="text-center py-10 text-gray-400">

                                No content available

                            </div>

                        ) : (

                            <div className="space-y-5">

                                {/* ================= VIDEOS ================= */}

                                {(groupedContents["mp4"] || []).length > 0 && (

                                    <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

                                        <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-purple-50">

                                            <div>

                                                <h2 className="text-xl font-bold text-purple-700">

                                                    🎥 Class Recording

                                                </h2>

                                                <p className="text-sm text-gray-500">

                                                    {(groupedContents["mp4"] || []).length}
                                                    {" "}
                                                    Videos Available

                                                </p>

                                            </div>

                                            <span className="text-purple-700 text-xl">

                                                ▼

                                            </span>

                                        </summary>

                                        <div className="p-4 space-y-3">

                                            {(groupedContents["mp4"] || []).map(
                                                (content, index) => (

                                                    <div
                                                        key={content.contentid}
                                                        // onClick={() =>
                                                        //     window.open(
                                                        //         content.playUrl,
                                                        //         "_blank"
                                                        //     )
                                                        // }

                                                        onClick={() =>
                                                            navigate("/player", {
                                                                state: {
                                                                    url: content.playUrl
                                                                }
                                                            })
                                                        }
                                                        className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-purple-50 transition"
                                                    >

                                                        <div className="flex items-center gap-3">

                                                            <span className="text-purple-700 font-semibold">

                                                                🎥

                                                            </span>

                                                            <span className="font-medium text-gray-700">

                                                                {content.displayname ||
                                                                    `Video ${index + 1}`}

                                                            </span>

                                                        </div>

                                                        <span className="text-sm text-purple-600 font-semibold">

                                                            Play

                                                        </span>

                                                    </div>
                                                )
                                            )}

                                        </div>

                                    </details>
                                )}

                                {/* ================= PDF ================= */}

                                {(groupedContents["pdf"] || []).length > 0 && (

                                    <details className="border rounded-2xl bg-white shadow-sm overflow-hidden">

                                        <summary className="cursor-pointer list-none flex justify-between items-center px-6 py-5 bg-blue-50">

                                            <div>

                                                <h2 className="text-xl font-bold text-blue-700">

                                                    📄 Class Notes

                                                </h2>

                                                <p className="text-sm text-gray-500">

                                                    {(groupedContents["pdf"] || []).length}
                                                    {" "}
                                                    Notes Available

                                                </p>

                                            </div>

                                            <span className="text-blue-700 text-xl">

                                                ▼

                                            </span>

                                        </summary>

                                        <div className="p-4 space-y-3">

                                            {(groupedContents["pdf"] || []).map(
                                                (content, index) => (

                                                    <div
                                                        key={content.contentid}
                                                        // onClick={() =>
                                                        //     window.open(
                                                        //         content.playUrl,
                                                        //         "_blank"
                                                        //     )
                                                        // }
                                                        onClick={() =>
                                                            navigate("/player", {
                                                                state: {
                                                                    url: content.playUrl
                                                                }
                                                            })
                                                        }

                                                        className="flex items-center justify-between border rounded-lg px-4 py-3 cursor-pointer hover:bg-blue-50 transition"
                                                    >

                                                        <div className="flex items-center gap-3">

                                                            <span className="text-blue-700 font-semibold">

                                                                📄

                                                            </span>

                                                            <span className="font-medium text-gray-700">

                                                                {content.displayname ||
                                                                    `Notes ${index + 1}`}

                                                            </span>

                                                        </div>

                                                        <span className="text-sm text-blue-600 font-semibold">

                                                            Open

                                                        </span>

                                                    </div>
                                                )
                                            )}

                                        </div>

                                    </details>
                                )}

                            </div>
                        )}

                    </div>
                )}

        </div>
    );
}

export default Calendar;


